import React, { Component } from "react";
import PropTypes from "prop-types";
import "./LoginForm.scss";
import { Input } from "../../common/Input/Input";
import { Button } from "../../common/Button/Button";
import logo from "./../../assets/logo.png";
import GoogleLogin from 'react-google-login';
import { GOOGLE_CLIENT_ID } from "../../utils/constants";
import Spinner from "../../common/Spinner/Spinner";

export class LoginForm extends Component {
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.props.onLoginClick();
    }
  };
  render() {
    return (
      <div className={`login-container ${this.props.isLoading && "set-opacity"}`}>
        <div className="login-form-container">
          <div className="login-form text-center">
            <div className="text-center mt10 mb20">
              <img
                alt="deasra-logo"
                src={logo}
                className="h40 mb20 logo-img"
              />
            </div>
            {this.props.isLoading && <Spinner className="center-screen" />}
            <div>
              <GoogleLogin clientId={GOOGLE_CLIENT_ID} onSuccess={this.props.onGoogleLoginSuccess} />
            </div>
            <div className="mt-3 mb-3">
              <h6 className="text-divider"><span>OR</span></h6>
            </div>
            <Input
              className="username"
              name="username"
              placeholder="Username"
              onChange={({ target }) => this.props.onInputChange(target)}
            />
            <Input
              type="password"
              name="password"
              className="password"
              placeholder="Password"
              onChange={({ target }) => this.props.onInputChange(target)}
              onKeyPress={this.handleKeyPress}
            />
            {this.props.error ? (
              <div className="form-error">{this.props.error}</div>
            ) : null}
            <div className="flex justify-content-stretch mt20">
              <Button
                className="w100p pt10 pb10"
                primary
                onClick={this.props.onLoginClick}
              >
                Log In
              </Button>
            </div>
            <div className="flex justify-content-center mt20">
              <a
                href="/forgot_password"
                className="ml10 text-link cursor-pointer"
              >
                Forgot Password?
              </a>
              <a
                onClick={this.props.onClearClick}
                className="ml10 text-link cursor-pointer"
              >
                Clear Session
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onInputChange: PropTypes.func,
  onLoginClick: PropTypes.func
};
